import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';

export default function PricelistPage() {
  const priceCategories = [
    {
      category: 'Bridal & Formal Wear',
      icon: 'ri-heart-line',
      color: 'amber',
      items: [
        { service: 'Wedding Dress - Basic Alterations', price: '$150 - $300' },
        { service: 'Wedding Dress - Complex Alterations', price: '$300 - $600' },
        { service: 'Bustle Addition (4-6 points)', price: '$75 - $150' },
        { service: 'Train Hemming', price: '$80 - $120' },
        { service: 'Bodice Alterations', price: '$100 - $200' },
        { service: 'Beadwork & Embellishment Repair', price: '$50 - $150' },
        { service: 'Bridesmaid Dress Alterations', price: '$40 - $80' },
        { service: 'Prom Dress Alterations', price: '$50 - $100' },
        { service: 'Evening Gown Alterations', price: '$50 - $100' },
      ],
    },
    {
      category: 'Men\'s Tailoring',
      icon: 'ri-user-line',
      color: 'gray',
      items: [
        { service: 'Suit Jacket - Sleeves', price: '$25 - $40' },
        { service: 'Suit Jacket - Sides/Waist', price: '$35 - $60' },
        { service: 'Suit Jacket - Shoulders', price: '$60 - $100' },
        { service: 'Suit Pants - Hem', price: '$30 - $40' },
        { service: 'Suit Pants - Waist', price: '$20 - $35' },
        { service: 'Suit Pants - Taper', price: '$25 - $40' },
        { service: 'Tuxedo Alterations', price: '$80 - $150' },
        { service: 'Dress Shirt - Sleeves', price: '$15 - $25' },
        { service: 'Dress Shirt - Sides', price: '$20 - $30' },
      ],
    },
    {
      category: 'Women\'s Alterations',
      icon: 'ri-shirt-line',
      color: 'rose',
      items: [
        { service: 'Dress - Hem (Simple)', price: '$20 - $35' },
        { service: 'Dress - Hem (Lined/Complex)', price: '$35 - $60' },
        { service: 'Dress - Sides/Waist', price: '$30 - $50' },
        { service: 'Dress - Shoulders/Straps', price: '$25 - $45' },
        { service: 'Pants - Hem (Simple)', price: '$12 - $20' },
        { service: 'Pants - Hem (Cuffed/Original)', price: '$18 - $30' },
        { service: 'Pants - Waist', price: '$18 - $30' },
        { service: 'Pants - Taper', price: '$25 - $40' },
        { service: 'Skirt - Hem', price: '$15 - $30' },
        { service: 'Skirt - Waist', price: '$20 - $35' },
        { service: 'Blouse/Top - Sides', price: '$20 - $35' },
        { service: 'Blouse/Top - Sleeves', price: '$15 - $25' },
      ],
    },
    {
      category: 'Specialty Services',
      icon: 'ri-scissors-line',
      color: 'blue',
      items: [
        { service: 'Zipper Replacement (Regular)', price: '$20 - $35' },
        { service: 'Zipper Replacement (Invisible)', price: '$30 - $50' },
        { service: 'Zipper Replacement (Heavy Duty)', price: '$35 - $60' },
        { service: 'Leather/Suede Alterations', price: '$40 - $100' },
        { service: 'Button Replacement (per button)', price: '$3 - $8' },
        { service: 'Patch/Repair Work', price: '$15 - $50' },
        { service: 'Lining Replacement', price: '$40 - $80' },
        { service: 'Custom Fitting Consultation', price: '$50' },
        { service: 'Rush Service (48 hours)', price: '+50% of base price' },
        { service: 'Same Day Service', price: '+100% of base price' },
      ],
    },
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative h-96 flex items-center justify-center bg-gradient-to-r from-gray-900 to-gray-700">
        <div className="absolute inset-0 opacity-20">
          <img
            src="https://public.readdy.ai/ai/img_res/fd539ad517c09b87b651ac379a4f56a9.jpg"
            alt="Price List"
            className="w-full h-full object-cover object-top"
          />
        </div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center text-white">
          <h1 className="text-5xl md:text-6xl font-bold mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
            Transparent Pricing
          </h1>
          <p className="text-xl md:text-2xl max-w-3xl mx-auto">
            Quality alterations at fair prices. No hidden fees, just honest service.
          </p>
        </div>
      </section>

      {/* Important Notice */}
      <section className="py-12 bg-amber-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white p-8 rounded-lg shadow-md border-l-4 border-amber-700">
            <div className="flex items-start">
              <div className="w-12 h-12 flex items-center justify-center bg-amber-100 rounded-full mr-4 flex-shrink-0">
                <i className="ri-information-line text-2xl text-amber-700"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-gray-900 mb-2">Pricing Information</h3>
                <p className="text-gray-700 leading-relaxed mb-2">
                  Prices listed are estimates and may vary based on garment complexity, fabric type, and specific requirements. 
                  Final pricing will be determined during your consultation after examining the garment.
                </p>
                <p className="text-gray-700 leading-relaxed">
                  <strong>Rush services available:</strong> 48-hour service (+50%) and same-day service (+100%) for urgent needs.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Price Lists */}
      {priceCategories.map((category, categoryIndex) => (
        <section
          key={categoryIndex}
          className={`py-16 ${categoryIndex % 2 === 0 ? 'bg-white' : 'bg-gray-50'}`}
        >
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-12">
              <div className={`w-16 h-16 flex items-center justify-center bg-${category.color}-700 rounded-full mx-auto mb-4`}>
                <i className={`${category.icon} text-3xl text-white`}></i>
              </div>
              <h2 className="text-4xl font-bold text-gray-900 mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
                {category.category}
              </h2>
            </div>

            <div className="bg-white rounded-lg shadow-md overflow-hidden border border-gray-200">
              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead className="bg-gray-900 text-white">
                    <tr>
                      <th className="px-6 py-4 text-left text-lg font-semibold">Service</th>
                      <th className="px-6 py-4 text-right text-lg font-semibold">Price Range</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {category.items.map((item, itemIndex) => (
                      <tr
                        key={itemIndex}
                        className="hover:bg-gray-50 transition-colors"
                      >
                        <td className="px-6 py-4 text-gray-900">{item.service}</td>
                        <td className="px-6 py-4 text-right font-semibold text-gray-900">
                          {item.price}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      ))}

      {/* Additional Information */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center p-8 bg-gradient-to-br from-amber-50 to-white rounded-lg shadow-md">
              <div className="w-16 h-16 flex items-center justify-center bg-amber-700 rounded-full mx-auto mb-4">
                <i className="ri-time-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Standard Turnaround</h3>
              <p className="text-gray-700">Most alterations completed within 5-7 business days</p>
            </div>

            <div className="text-center p-8 bg-gradient-to-br from-amber-50 to-white rounded-lg shadow-md">
              <div className="w-16 h-16 flex items-center justify-center bg-amber-700 rounded-full mx-auto mb-4">
                <i className="ri-shield-check-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Quality Guarantee</h3>
              <p className="text-gray-700">We stand behind our work with a satisfaction guarantee</p>
            </div>

            <div className="text-center p-8 bg-gradient-to-br from-amber-50 to-white rounded-lg shadow-md">
              <div className="w-16 h-16 flex items-center justify-center bg-amber-700 rounded-full mx-auto mb-4">
                <i className="ri-money-dollar-circle-line text-3xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Payment Options</h3>
              <p className="text-gray-700">Cash, credit cards, and digital payments accepted</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-20 bg-gray-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h2 className="text-4xl font-bold text-gray-900 mb-12 text-center" style={{ fontFamily: '"Playfair Display", serif' }}>
            Frequently Asked Questions
          </h2>

          <div className="space-y-6">
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h4 className="text-lg font-bold text-gray-900 mb-2">Do you offer free consultations?</h4>
              <p className="text-gray-700">Yes! We provide complimentary consultations to assess your alteration needs and provide accurate pricing.</p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md">
              <h4 className="text-lg font-bold text-gray-900 mb-2">What payment methods do you accept?</h4>
              <p className="text-gray-700">We accept cash, all major credit cards, debit cards, and digital payment methods including Apple Pay.</p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md">
              <h4 className="text-lg font-bold text-gray-900 mb-2">Can you handle rush orders?</h4>
              <p className="text-gray-700">Yes! We offer 48-hour rush service for an additional 50% and same-day service for an additional 100% of the base price, subject to availability.</p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md">
              <h4 className="text-lg font-bold text-gray-900 mb-2">Do prices include multiple fittings?</h4>
              <p className="text-gray-700">Yes, our prices include up to two fittings to ensure perfect results. Additional fittings may incur a small fee.</p>
            </div>

            <div className="bg-white p-6 rounded-lg shadow-md">
              <h4 className="text-lg font-bold text-gray-900 mb-2">What if I'm not satisfied with the alterations?</h4>
              <p className="text-gray-700">Customer satisfaction is our priority. If you're not completely satisfied, we'll make it right at no additional charge.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-amber-700 to-amber-900 text-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold mb-6" style={{ fontFamily: '"Playfair Display", serif' }}>
            Ready to Get Started?
          </h2>
          <p className="text-xl mb-8">
            Book your free consultation today and get an accurate quote for your alterations.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link
              to="/contact"
              className="bg-white text-amber-900 px-8 py-4 rounded-md text-lg font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer"
            >
              Book Free Consultation
            </Link>
            <Link
              to="/services"
              className="bg-transparent border-2 border-white text-white px-8 py-4 rounded-md text-lg font-semibold hover:bg-white hover:text-amber-900 transition-colors whitespace-nowrap cursor-pointer"
            >
              View Services
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
